module.exports = __webpack_public_path__ + "img/bg02.eac1d31e.png";